/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type InvitationCodeEditQueryVariables = {
    id: string;
};
export type InvitationCodeEditQueryResponse = {
    readonly invitationCodeById: {
        readonly id: string;
        readonly invitationCode: string;
        readonly role: string;
        readonly isActive: boolean;
        readonly name: string | null;
        readonly maximalAccounts: number;
        readonly creator: {
            readonly name: string;
        } | null;
    } | null;
};
export type InvitationCodeEditQuery = {
    readonly response: InvitationCodeEditQueryResponse;
    readonly variables: InvitationCodeEditQueryVariables;
};



/*
query InvitationCodeEditQuery(
  $id: ID!
) {
  invitationCodeById(id: $id) {
    id
    invitationCode
    role
    isActive
    name
    maximalAccounts
    creator {
      name
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invitationCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maximalAccounts",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvitationCodeEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InvitationCode",
        "kind": "LinkedField",
        "name": "invitationCodeById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicUser",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvitationCodeEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InvitationCode",
        "kind": "LinkedField",
        "name": "invitationCodeById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicUser",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "805191de0e9f3ff48adf3f71c27b03e5",
    "id": null,
    "metadata": {},
    "name": "InvitationCodeEditQuery",
    "operationKind": "query",
    "text": "query InvitationCodeEditQuery(\n  $id: ID!\n) {\n  invitationCodeById(id: $id) {\n    id\n    invitationCode\n    role\n    isActive\n    name\n    maximalAccounts\n    creator {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bac572e184cad6d431fba45c80d188a0';
export default node;
